import { Reducer } from "redux";

import { ExcelDownloadResponse } from "../models/api/Scorecard";
import { ExcelDownloadActionDispatchTypes } from "../models/dispatchTypes/Scorecard";
import { GetExcelActionDispatchTypes } from "../constants/Scorecard";

const initialState: ExcelDownloadResponse = {
  loading: false,
  response: {} as Blob,
  error: null,
};

const ExcelDownloadReducer: Reducer<
ExcelDownloadResponse,
ExcelDownloadActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetExcelActionDispatchTypes.GET_EXCEL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetExcelActionDispatchTypes.GET_EXCEL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetExcelActionDispatchTypes.GET_EXCEL_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetExcelActionDispatchTypes.GET_EXCEL_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ExcelDownloadReducer;